export const context = 'maqari_school'

if (typeof window !== 'undefined') {
  ;(window as any).school_context = context
}
